// BackgroundManager.js
import "../phaser.min.js";
import ReflectionBackground from "./ReflectionBackground";
import FarmBackground from "./FarmBackground";
import MountainBackground from "./MountainBackground";

class BackgroundManager extends Phaser.Scene {
    constructor() {
        super('BackgroundManager');
        this.currentBackground = null;
        this.backgrounds = new Map(); // key -> scene instance
    }

    init(data) {
        this.scrollSpeed = data.scrollSpeed;
    }

    preload() {


    }

    create() {
        // Pre-register your backgrounds
        this.registerBackground('ReflectionBackground', ReflectionBackground);
        this.registerBackground('FarmBackground', FarmBackground);
        this.registerBackground('MountainBackground', MountainBackground);
        // ... add more

        this.events.on('fire-background-event', (event) => {
            this.events.emit(this.currentBackground + '-fire-background-event')
        })
    }

    quizHandler = () => {
        let currentScene = this.scene.get(this.currentBackground)
        currentScene.quizEventHandler();
    }

    carHandler = () => {
        let car = this.scene.get('Car');
        let currentScene = this.scene.get(this.currentBackground)
        currentScene.carEventHandler();
    }

    registerBackground(key, SceneClass) {
        if (!this.scene.get(key)) {
            this.scene.add(key, SceneClass, false); // don't start yet
            this.scene.moveBelow('Start', key);
        }
        this.backgrounds.set(key, key);
    }

    transitionTo(newKey, scrollSpeed = 100) {

        const oldKey = this.currentBackground;

        if (oldKey === newKey) return;

        // Launch / wake new background
        if(this.scene.isSleeping(newKey)) {
            this.scene.wake(newKey);
        }else{
            this.scene.launch(newKey, {scrollSpeed: scrollSpeed});
        }
        this.scene.moveBelow(oldKey, newKey);

        // Fade out current
        if (oldKey) {
            this.events.emit(oldKey + '-fade-out')
        }

        this.currentBackground = newKey;

        if(this.scene.get('Quiz')) {
            this.quizHandler();
        }

        if(this.scene.get('Car')) {
            this.carHandler();
        }

    }
}

export default BackgroundManager;